import { JSEncrypt } from 'jsencrypt';

export class RsaUtil {
    public static encrypt(publicKey: string, plainText: string): string | false {
        let jsencrypt: JSEncrypt = new JSEncrypt({default_key_size : "1024"});
        jsencrypt.setPublicKey(publicKey);
        
        return jsencrypt.encrypt(plainText.trim());
    }
}